module.exports = __webpack_public_path__ + "static/media/An open market to sell goods.197afd2c.png";